import { DocsTemplates } from '@/enums';
import { DocsTemplateResponse, Response } from '@/types';
import { BaseApiService } from './base-service';

export class DocsTemplatesService extends BaseApiService {
  private base_path = 'documents';

  async get_document_template(doc: DocsTemplates): Promise<DocsTemplateResponse> {
    const url = `${this.base_path}/${doc}`;
    const { data } = await this.http_client.get<DocsTemplateResponse>(url);

    return data;
  }
}
